import { render } from "./ManageWorkspace.vue?vue&type=template&id=a1a5cecc&scoped=true"
import script from "./ManageWorkspace.vue?vue&type=script&lang=js"
export * from "./ManageWorkspace.vue?vue&type=script&lang=js"

import "./ManageWorkspace.vue?vue&type=style&index=0&id=a1a5cecc&scoped=true&lang=css"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a5cecc"]])

export default __exports__